export default "__VITE_ASSET__DpcE0dWe__"